export default {
    title: 'Trend evaluation',
    feedback: 'Thank you for your evaluation',
    submit: {
        next: 'Save and next',
        last: 'Save'
    },
    next: 'skip over',
    back: 'Back to overview',
    progress: 'Evaluation progress'
}
